/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Application_Motivation_LabelInputs */

const en_company_application_motivation_label = /** @type {(inputs: Company_Application_Motivation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

const de_company_application_motivation_label = /** @type {(inputs: Company_Application_Motivation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivation`)
};

/**
* | output |
* | --- |
* | "Motivation" |
*
* @param {Company_Application_Motivation_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_application_motivation_label = /** @type {((inputs?: Company_Application_Motivation_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Application_Motivation_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_application_motivation_label(inputs)
	return en_company_application_motivation_label(inputs)
});